import { render, staticRenderFns } from "./NewMotion.vue?vue&type=template&id=16a9d886&scoped=true&"
import script from "./NewMotion.vue?vue&type=script&lang=tsx&"
export * from "./NewMotion.vue?vue&type=script&lang=tsx&"
import style0 from "./NewMotion.vue?vue&type=style&index=0&id=16a9d886&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a9d886",
  null
  
)

export default component.exports